import React from 'react';
import { useDarkMode } from '../../../../context/DarkModeContext';
import { CheckIcon } from '@heroicons/react/24/solid';

interface WizardProgressProps {
  steps: string[];
  currentStep: number;
}

const WizardProgress: React.FC<WizardProgressProps> = ({ steps, currentStep }) => {
  const { darkMode } = useDarkMode();
  
  const activeColor = darkMode ? 'bg-blue-600' : 'bg-blue-500';
  const completeColor = darkMode ? 'bg-green-600' : 'bg-green-500';
  const inactiveColor = darkMode ? 'bg-gray-700' : 'bg-gray-300';
  const textColor = darkMode ? 'text-gray-300' : 'text-gray-700';
  const activeTextColor = darkMode ? 'text-blue-400' : 'text-blue-600';
  
  return (
    <div className="w-full">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isActive = index === currentStep;
          const isComplete = index < currentStep;
          
          return (
            <div key={step} className="flex-1 relative">
              {/* Line connector */}
              {index < steps.length - 1 && (
                <div
                  className={`absolute top-5 left-1/2 w-full h-0.5 ${
                    isComplete ? completeColor : inactiveColor
                  }`}
                />
              )}
              
              {/* Step indicator */}
              <div className="relative flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-medium z-10 ${
                    isComplete ? completeColor : isActive ? activeColor : inactiveColor
                  }`}
                >
                  {isComplete ? (
                    <CheckIcon className="w-5 h-5" />
                  ) : (
                    <span className="text-sm">{index + 1}</span>
                  )}
                </div>
                
                {/* Step label */}
                <span
                  className={`mt-2 text-xs font-medium ${
                    isActive ? activeTextColor : textColor
                  }`}
                >
                  {step}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WizardProgress;